module.exports = __webpack_public_path__ + "img/stock3.d2fd8d6a.png";